import { requestV3 } from 'Features/Auth/axios-client'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { ScenarioComparison } from 'Features/Projects/Analysis/Analysis.types'

const fetchScenarioComparison = async (projectId: string) => {
  const { data } = await requestV3({
    url: `/projects/scenario-comparison?projectId=${projectId}`,
    method: 'GET',
  })
  return data
}

export const useScenarioComparison = (
  projectId: string
): UseQueryResult<ScenarioComparison[]> => {
  return useQuery({
    queryKey: ['scenarioComparison', projectId],
    queryFn: () => fetchScenarioComparison(projectId),
    select: (data) => data.data,
    refetchOnWindowFocus: false,
    gcTime: 1 * 60 * 1000, // 1 minute - comparison data changes when scenarios change
    staleTime: 10 * 1000, // 10 seconds - consider fresh for 10 seconds
  })
}
